export default __webpack_public_path__ + "099f4053beec784ab9d0dc7043a872c2.svg";